const statisticsUrl = (orgs: string[], minDate: string, maxDate: string) => `statistics?org_names=${orgs}&min_date=${minDate}&max_date=${maxDate}`;
const ordersUsageUrl = (orgs: string[], minDate: string, maxDate: string, plotDateRange: string) => {
  return `statistics/orders_plot?org_names=${orgs}&min_date=${minDate}&max_date=${maxDate}&plot_date_range=${plotDateRange}`;
};

export default { statisticsUrl, ordersUsageUrl };
